module.exports = __webpack_public_path__ + "img/Keramik Pfau.ce3fb602.jpg";